/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * This are the analyticValue Ids for the DataChangeMultiData
 */
export interface AnalyticValueIds { 
    analyticValueIds?: Array<number>;
}

